import { createFileRoute, redirect } from '@tanstack/react-router';

import { getListCompaniesQueryOptions } from '../generated/api/companies/companies';

export const Route = createFileRoute('/manage/')({
  beforeLoad: async ({ context }) => {
    const response = await context.queryClient.ensureQueryData(getListCompaniesQueryOptions());
    if (response.status === 200 && response.data.items[0]) {
      // TanStack Router uses thrown redirect descriptors for route control flow.
      // eslint-disable-next-line @typescript-eslint/only-throw-error
      throw redirect({
        params: { companySlug: response.data.items[0].slug },
        to: '/manage/$companySlug/dashboard',
      });
    }
  },
  component: () => null,
});
